import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
} from '@mui/material';
import {
  Business,
  LocalShipping,
  Palette,
  Discount,
  CheckCircle,
  Store,
} from '@mui/icons-material';
import { motion } from 'framer-motion';

const BulkOrders: React.FC = () => {
  const benefits = [
    {
      icon: <Discount sx={{ fontSize: 50, color: '#8B7355' }} />,
      title: '50% OFF Retail Prices',
      description: 'Same ₹3L quality at ₹1.5L',
    },
    {
      icon: <Business sx={{ fontSize: 50, color: '#8B7355' }} />,
      title: 'Bulk Order Specialists',
      description: 'Trusted supplier to Aditya Birla, Reliance, METRO Cash & Carry, Future Group',
    },
    {
      icon: <Palette sx={{ fontSize: 50, color: '#8B7355' }} />,
      title: 'Elegant Customization',
      description: 'Any design, color, fabric - crafted to perfection',
    },
    {
      icon: <LocalShipping sx={{ fontSize: 50, color: '#8B7355' }} />,
      title: 'All Andhra and Telangana Delivery',
      description: 'Reliable delivery network across entire India',
    },
    {
      icon: <Store sx={{ fontSize: 50, color: '#8B7355' }} />,
      title: 'Wholesale & Retail',
      description: 'Bulk orders for businesses, individual sales too',
    },
    {
      icon: <CheckCircle sx={{ fontSize: 50, color: '#8B7355' }} />,
      title: 'Premium Quality',
      description: 'Same design & quality as luxury brands',
    },
  ];

  const clients = [
    'Aditya Birla',
    'Reliance',
    'METRO Cash & Carry',
    'Future Group',
    'Interior Designers',
    'Hotels & Resorts',
  ];

  return (
    <Box sx={{ py: { xs: 4, md: 8 }, backgroundColor: 'background.paper' }}>
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <Box sx={{ textAlign: 'center', mb: { xs: 3, md: 6 } }}>
            <Chip
              label="MANUFACTURER DIRECT"
              sx={{
                backgroundColor: '#8B7355',
                color: 'white',
                fontSize: '1rem',
                fontWeight: 'bold',
                px: 2,
                py: 3,
                mb: 2,
              }}
            />
            
            <Typography
              variant="h2"
              sx={{
                color: '#8B7355',
                fontWeight: 'bold',
                mb: 2,
                fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' },
              }}
            >
              Bulk Orders & Wholesale Pricing
            </Typography>
            
            <Typography
              variant="h5"
              sx={{
                color: '#8B7355',
                maxWidth: 800,
                mx: 'auto',
                mb: 2,
                fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' },
                px: { xs: 1, sm: 2 },
              }}
            >
              We are a manufacturing company serving bulk orders to major retailers 
              and individual customers at wholesale prices
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: '#8B7355',
                fontWeight: 'bold',
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' },
              }}
            >
              Premium Quality at 50% OFF - Direct Factory Prices!
            </Typography>
          </Box>
        </motion.div>

        <Grid container spacing={{ xs: 2, md: 3 }} sx={{ mb: { xs: 4, md: 6 } }}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: 280,
                    p: 3,
                    textAlign: 'center',
                    backgroundColor: 'white',
                    borderRadius: 2,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: '0 8px 20px rgba(139,115,85,0.15)',
                    },
                  }}
                >
                  <Box sx={{ mb: 2 }}>
                    {benefit.icon}
                  </Box>
                  <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#8B7355', fontSize: { xs: '0.95rem', sm: '1rem', md: '1.1rem' } }}>
                    {benefit.title}
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: { xs: '0.85rem', sm: '0.9rem' }, color: '#8B7355', lineHeight: 1.5 }}>
                    {benefit.description}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <Card
            sx={{
              background: '#8B7355',
              color: 'white',
              p: { xs: 2, sm: 3, md: 4 },
              mb: { xs: 3, md: 4 },
            }}
          >
            <Typography
              variant="h4"
              sx={{ color: 'white', textAlign: 'center', mb: { xs: 2, md: 3 }, fontWeight: 'bold', fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' } }}
            >
              We Serve
            </Typography>
            
            <Grid container spacing={{ xs: 1, sm: 2 }} justifyContent="center">
              {clients.map((client, index) => (
                <Grid item key={index}>
                  <Chip
                    label={client}
                    sx={{
                      backgroundColor: 'rgba(255,255,255,0.08)',
                      color: 'white',
                      fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
                      fontWeight: 'bold',
                      px: { xs: 1, sm: 1.5, md: 2 },
                      py: { xs: 2, sm: 2.5, md: 3 },
                      border: '2px solid white',
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Card>
        </motion.div>

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h5" sx={{ color: '#8B7355', mb: { xs: 2, md: 3 }, fontWeight: 'bold', fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' } }}>
            Ready to Order? Get Your Custom Quote Today!
          </Typography>
          
          <Box sx={{ display: 'flex', gap: { xs: 1.5, sm: 2 }, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              size="large"
              href="https://wa.me/916309561983?text=Hello%20Ahmed%20Concept%20Sofas!%20I'm%20interested%20in%20bulk%20orders.%20Please%20share%20wholesale%20pricing%20and%20customization%20options."
              target="_blank"
              sx={{
                px: { xs: 2.5, sm: 3, md: 4 },
                py: { xs: 1.5, sm: 1.75, md: 2 },
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                fontWeight: 'bold',
                color: 'white',
                backgroundColor: '#8B7355',
                borderColor: '#8B7355',
                '&:hover': {
                  backgroundColor: 'rgba(139,115,85,0.9)',
                },
              }}
            >
              Order on WhatsApp
            </Button>
            
            <Button
              variant="outlined"
              size="large"
              href="#products"
              sx={{
                px: { xs: 2.5, sm: 3, md: 4 },
                py: { xs: 1.5, sm: 1.75, md: 2 },
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                fontWeight: 'bold',
                color: '#8B7355',
                borderColor: '#8B7355',
              }}
            >
              View Products
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default BulkOrders;
